import React from "react";
import styled from "styled-components";
import { Button} from "antd";
const AlertSummaryCard = styled.div`
    border-radius:8px;
    &.red{
    .alertBox{
        border:1px solid rgba(236, 78, 44, 0.2);
        background-color:rgba(235, 78, 44, 0.1);
    }
    }
    &.yellow{
        .alertBox{
            background: rgba(238, 149, 0, 0.1);
            border: 1px solid rgba(238, 149, 0, 0.2);
        }
    }
    .alertBox{
      padding:4px 30px 4px 12px;
      border-radius:8px;
      min-height:30px;
      width:100%;
      display:flex;
      .alertIcon{
          width:20px;
          height:20px;
          position:relative;
          top:-2px;
          align-self:center;
          img{
              width:100%;
          }
      }
      p{
        color:var(--theme-color);
        font-size:12px;
        line-height:16px;
        font-family:var(--sf-pro-display-m);
        margin-left:15px;
        margin-bottom:0px;
        padding-top: 10px;
      }
      .ant-btn.themeBtn.noBg.noMargin{
          border:none!important;
          span{
                border-bottom: 1px solid var(--theme-color) !important;
                font-size: 14px;
          }
      }
    }
`;

const AlertSummaryTableContainer = (props) => {
    return (<AlertSummaryCard className={props.color} > 
    <div className="alertBox">
        <div className="alertIcon">
            <img src={props.icon} alt=""/>
        </div>
        <p>{props.msg}</p>
        <Button key="1" className="themeBtn noBg noMargin" > {props.button}</Button>
    </div>
    </AlertSummaryCard>)
}
export default AlertSummaryTableContainer;